import { CdkScrollable, ScrollDispatcher } from "@angular/cdk/scrolling";
import { AfterViewInit, DestroyRef, Directive, ElementRef, NgZone, OnDestroy, OnInit, Optional, Renderer2, Self } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { distinctUntilChanged, map, pairwise, startWith } from "rxjs/operators";

enum ShowShadow {
	Top = 1,
	Bottom = 2,
}

enum StyleClasses {
	Base = "acp-scroll-shadow",
	Top = "acp-scroll-shadow-top",
	Bottom = "acp-scroll-shadow-bottom",
}

@Directive({ selector: "[acpScrollShadow],mat-dialog-content", standalone: true })
export class ScrollShadowDirective implements OnInit, AfterViewInit, OnDestroy {
	//

	private scrollable?: CdkScrollable;

	constructor(
		//
		private readonly elRef: ElementRef<HTMLElement>,
		private readonly renderer: Renderer2,
		private readonly scrollDispatcher: ScrollDispatcher,
		private readonly destroyRef: DestroyRef,
		ngZone: NgZone,
		@Self() @Optional() scrollable?: CdkScrollable
	) {
		if (!scrollable) {
			this.scrollable = new CdkScrollable(elRef, scrollDispatcher, ngZone);
		}
	}

	ngOnInit(): void {
		this._addClass(StyleClasses.Base);
		this.scrollable?.ngOnInit();
	}

	ngAfterViewInit(): void {
		const el = this.elRef.nativeElement;

		this.scrollDispatcher
			.ancestorScrolled(this.elRef, 33)

			.pipe(
				startWith(null),
				map(() => {
					const { scrollTop, scrollHeight, clientHeight } = el;
					const showTopShadow = Math.floor(scrollTop) < 1 ? 0 : ShowShadow.Top;
					const showBottomShadow = clientHeight + Math.round(scrollTop + 0.5) >= scrollHeight ? 0 : ShowShadow.Bottom;
					return showTopShadow | showBottomShadow;
				}),
				distinctUntilChanged(),
				startWith(0),
				pairwise(),
				takeUntilDestroyed(this.destroyRef)
			)
			.subscribe(([prev, next]) => {
				const prevTop = !!(prev & ShowShadow.Top);
				const nextTop = !!(next & ShowShadow.Top);
				const prevBottom = !!(prev & ShowShadow.Bottom);
				const nextBottom = !!(next & ShowShadow.Bottom);

				if (prevTop && !nextTop) this._removeClass(StyleClasses.Top);
				if (!prevTop && nextTop) this._addClass(StyleClasses.Top);
				if (prevBottom && !nextBottom) this._removeClass(StyleClasses.Bottom);
				if (!prevBottom && nextBottom) this._addClass(StyleClasses.Bottom);
			});
	}

	ngOnDestroy(): void {
		this.scrollable?.ngOnDestroy();
	}

	private _addClass(className: string) {
		this.renderer.addClass(this.elRef.nativeElement, className);
	}
	private _removeClass(className: string) {
		this.renderer.removeClass(this.elRef.nativeElement, className);
	}
}
